var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrinter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 6 16 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M22.5 9a.5.5 0 0 1 .5.5V16h-2v-4H9v4H7V9.5a.5.5 0 0 1 .5-.5H10V6.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5V9zM10 25V13h10v12zm9-1V14h-8v10zm-7-7v-1h6v1zm0 2v-1h6v1zm0 2v-1h6v1z"
})));
export default SvgPrinter;